app.component('userPolicy', {
    templateUrl: 'app/userpolicy/user_policy.html',
    controller: function($window, $mdSidenav, $route, $location, localStorageAccess) {
        var $ctrl = this;
        $ctrl.$onInit = function() {
            if(!$location.search() === "undefined") {
                $ctrl.lang = $location.search()["lang"];
            }
            $ctrl.agreePolicy = false;
            var appData = localStorageAccess.getData( "app" );
            if(appData.userPolicy != null && appData.userPolicy != "0") {
                $ctrl.userPolicyAgree = true;
            }
            else {
                $ctrl.userPolicyAgree = false;
            }
        };
        $ctrl.startApp = function() {
            var appData = localStorageAccess.getData( "app" );
            appData.userPolicy = "1";
            localStorageAccess.setData("app", appData);
            $location.path("/home");
            $route.reload();
        };
        $ctrl.goUserPolicy = function() {
            $location.path("/user_policy");
        }
        $ctrl.toggleLeftMenu = function() {
            $mdSidenav('left').toggle();
        };
        $ctrl.langChange = function(lang) {
            if(lang=="en") {
                $window.location.href = "/user_policy";
            }
            else {
                $window.location.href = "/user_policy?lang=en";
            }
        };
    }
});

